module.exports = __webpack_public_path__ + "img/left-lightning5.9c552315.png";